import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreatePolicyDto } from './create-policy.dto';

/**
 * Update policy DTO
 */
export class UpdatePolicyDto extends CreatePolicyDto {
	@TransformInt()
	id!: number;
}
